function e(e){return"object"==typeof e&&e.hasOwnProperty("value")}export{e as isDesignToken};
//# sourceMappingURL=designToken.js.map
